module.exports = __webpack_public_path__ + "images/fa-fw2024-tracks.webp";